import React from "react";

import { NotificationsContext } from "./NotificationsProvider";

import { getCurrentLanguage } from "../LanguageHelper";

import { useNavigate, useParams } from "react-router";

// API Link Component props:
// APICall: required, function to use when calling API. function returns state and throws errors.
// to: optional, mimics behaviour of Link component from react-router.
export const processAPIRoute = (props, context) => async () => {
  context.setLoading(true);
  try {
    const state = await props.APICall();
    context.setLoading(false);
    const lang = getCurrentLanguage(props.match);

    // Build pathname and search string consistently whether `to` is a string or a location-like object
    const toObj =
      typeof props.to === "string" ? { pathname: props.to } : props.to || {};
    const path = toObj.pathname || "";
    const search = toObj.search || "";

    // Ensure leading slash and language prefix
    const pathname = `/${lang}/${path}`.replace(/\/+/g, "/");

    // Use navigate(path, { state }) signature to reliably pass state
    const target = `${pathname}${search}`;
    props.navigate(target, { state });
  } catch (e) {
    context.setLoading(false);
    context.pushNotification(e);
  }
};

const APILink = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <NotificationsContext.Consumer>
      {(context) => (
        <div
          style={props.style}
          onClick={
            props.disabled
              ? null
              : processAPIRoute({ ...props, navigate, params }, context)
          }
          data-test={props["data-test"]}
        >
          {props.children}
        </div>
      )}
    </NotificationsContext.Consumer>
  );
};

export default APILink;